import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../authApi";

export default function ProtectedRoute({ children, adminOnly = true }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center">
        <div className="text-sm text-[#C19A6B] uppercase tracking-[0.25em] animate-pulse">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to={`/admin/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (adminOnly && user.role !== "admin" && user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}
